import React from 'react';
import Link from 'Components/Link';

import ListPageHeader from 'Components/ListPageHeader';
import styles from './AdminPageV2.scss';
import { ROUTES } from '../../settings/route-strings';

function AdminPageV2(props) {
  const { children } = props;
  const links = [
    { label: 'Schools', to: ROUTES.ADMIN_V2_STATS_SCHOOLS },
    { label: 'Educators', to: ROUTES.ADMIN_V2_STATS_EDUCATORS },
    { label: 'Graphs', to: ROUTES.ADMIN_V2_STATS_GRAPHS },
  ];

  return (
    <main className="Page__content">
      <div className="AdminPageV2">
        <ListPageHeader
          pageTitle="Tinybop Admin Stats"
          handleTabClick={() => null}
          message={null}
          isSticky={false}
        />
        <nav>
          {links.map(({ label, to }) => (
            <Link className="SiteNav__link" activeClassName="is-active" to={to}>
              {label}
            </Link>
          ))}
        </nav>
        <div className="Content">{children}</div>
      </div>
    </main>
  );
}

export default AdminPageV2;
